import { render, staticRenderFns } from "./AyudadxConclusion.vue?vue&type=template&id=f10c27c2"
import script from "./AyudadxConclusion.vue?vue&type=script&lang=js"
export * from "./AyudadxConclusion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports